export const GET_ALL_LEVELS = 'get_all_levels';
export const GET_ALL_LEVELS_SUCCESS = 'get_all_levels_success';
export const GET_ALL_COURSES = 'get_all_courses';
export const GET_ALL_COURSES_SUCCESS = 'get_all_courses_success';
export const ADD_LEVEL ='add_level';
export const EDIT_LEVEL ='edit_level';
export const DELETE_LEVEL='delete_level';
export const GET_LEVEL_DETAIL='get_level_detail';
export const GET_LEVEL_DETAIL_SUCCESS='get_level_detail_success';
export const SET_LOADER = 'set_loader';